import React, { useCallback, useEffect, useState } from 'react';
import { GripVertical } from 'lucide-react';

interface ResizeHandleProps {
  onResize: (newWidth: number) => void;
}

export default function ResizeHandle({ onResize }: ResizeHandleProps) {
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;

      const windowWidth = window.innerWidth;
      const newWidth = (e.clientX / windowWidth) * 100;
      onResize(newWidth);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, onResize]);

  return (
    <div
      className={`w-4 h-full cursor-col-resize flex items-center justify-center
        hover:bg-gray-200 active:bg-gray-300 transition-colors
        ${isDragging ? 'bg-gray-300' : ''}
      `}
      style={{
        position: 'relative',
        margin: '0 -8px',
        zIndex: 10,
      }}
      onMouseDown={handleMouseDown}
    >
      <div className="h-16 flex items-center justify-center">
        <GripVertical className="w-4 h-4 text-gray-400" />
      </div>
    </div>
  );
}